import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  useGetUserDetailsQuery,
  useGetPartnerUserDetailsQuery,
  useGetUserProfilePicQuery,
  useGetUserProfileLogoQuery,
} from "../store/authApiSlice";
import {
  getCurrentUser,
  getLoggedUserDetails,
  getLoginLogoutUserStatus,
  getUserProfilePic,
  getLoggedPartnerUserDetails,
  loginStatusUpdate,
  loginLogoutUpdateStatus,
} from "../store/auth";
import { useDispatch, useSelector } from "react-redux";
import ChangePassword from "../../Components/ChangePassword";
import Help from "../../Components/Support/Help";
import SupportPupup from "../../Components/Support/SupportPopup";
import AddSecurityQuestion from "../../Components/ApplicantProcessing/AddSecurityQuestion";
import Profile from "../../Components/Comman/Profile";
import WelcomePage from "../../Components/WelcomePage";
import { getPageTitle, getWorkbenchHelpDocs, loadWorkbenchHelpDocs } from "../store/layoutUI";
import config from "../../config.json";
import { getFieldData } from "../../Services/appService";

const HEADER_STYLES = {
    shell: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        background: "#ffffff",
        boxShadow: "0 14px 40px rgba(15, 23, 42, 0.08)",
        color: "#0f172a",
        overflow: "visible",
        position: "relative",
        width: "100%",
        borderBottom: "1px solid rgba(203, 213, 225, 0.85)"
    },
    topRow: {
        borderBottom: "1px solid rgba(203, 213, 225, 0.75)",
        position: "relative",
        zIndex: 5
    },
    subtitle: {
        fontSize: "12px",
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        color: "rgba(221, 230, 241, 0.84)",
        marginBottom: "8px"
    },
    title: {
        fontSize: "34px",
        fontWeight: 700,
        lineHeight: 1.1,
        marginBottom: "10px",
        color: "#f8fbff"
    },
    titleSupport: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        fontSize: "15px",
        fontWeight: 600,
        color: "#ffffff",
        letterSpacing: "0.02em",
        textAlign: "center",
        flex: 1
    },
    titleSupportWrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "4px 0 8px 0",
        color: "#ffffff",
        position: "relative",
        zIndex: 1
    },
    titleSupportAccent: {
        width: "22px",
        height: "1px",
        background: "rgba(255, 255, 255, 0.55)",
        flexShrink: 0
    },
    brandRow: {
        display: "flex",
        alignItems: "flex-start",
        gap: "20px",
        marginBottom: "4px",
        flexWrap: "wrap"
    },
    brandCopy: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "6px",
        paddingTop: "2px"
    },
    brandLogo: {
        height: "84px",
        width: "auto",
        display: "block",
        backgroundColor: "#ffffff",
        padding: "8px 12px",
        borderRadius: "0",
    },
    profileCard: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "14px",
        width: "100%",
        minHeight: "84px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        background: "#ffffff",
        borderRadius: "0",
        padding: "12px 14px",
        color: "#0f172a",
        backdropFilter: "blur(6px)",
        overflow: "visible",
        zIndex: 6
    },
    profileMain: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        minWidth: 0,
        flex: 1
    },
    avatar: {
        width: "50px",
        height: "50px",
        objectFit: "cover",
        borderRadius: "50%",
        border: "2px solid rgba(228, 236, 244, 0.45)",
    },
    userContent: {
        minWidth: 0,
        flex: 1
    },
    userName: {
        fontSize: "17px",
        fontWeight: 700,
        lineHeight: 1.2,
        marginBottom: "6px",
        color: "#0f172a"
    },
    detailRow: {
        display: "flex",
        flexWrap: "wrap",
        gap: "6px",
        marginBottom: "5px"
    },
    detailPill: {
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "4px 10px",
          borderRadius: "0",
          backgroundColor: "transparent",
          border: "1px solid #e2e8f0",
          fontSize: "12px",
          color: "#334155",
          fontWeight: 600,
          lineHeight: 1
      },
    userMeta: {
        fontSize: "12px",
        color: "#64748b",
        marginBottom: "0"
    },
    dropdownButton: {
        border: "none",
        background: "#e2e8f0",
        color: "#334155",
        width: "30px",
        height: "30px",
        borderRadius: "0",
        cursor: "pointer"
    },
    quickRow: {
        position: "relative",
        zIndex: 1,
        borderBottom: "1px solid rgba(255, 255, 255, 0.15)"
    },
    darkBanner: {
        background: 'rgba(12, 12, 14, 0.9) url("/assets/Img/slide3.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        marginLeft: "-15px",
        marginRight: "-15px",
        padding: "0 15px"
    },
    quickRowInner: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        flexWrap: "wrap"
    },
    quickInfoBlock: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        minHeight: "40px"
    },
    portalBadge: {
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "0",
        border: "1px solid #93c5fd",
        background: "linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%)",
        padding: "7px 14px",
        fontSize: "12px",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        color: "#1e40af",
        boxShadow: "0 2px 5px rgba(30, 64, 175, 0.12)",
        cursor: "pointer"
    },
    quickHint: {
        fontSize: "12px",
        color: "#64748b",
        letterSpacing: "0.02em"
    },
    quickButton: {
        borderRadius: "0",
        border: "1px solid #cbd5e1",
        background: "linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%)",
        color: "#0f172a",
        padding: "7px 14px",
        fontSize: "13px",
        fontWeight: 600,
        marginTop: "0",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(15, 23, 42, 0.08)",
        transition: "all 0.2s ease"
    },
    logoutButton: {
        borderRadius: "0",
        border: "1px solid #fca5a5",
        background: "linear-gradient(180deg, #fef2f2 0%, #fee2e2 100%)",
        color: "#991b1b",
        padding: "7px 14px",
        fontSize: "13px",
        fontWeight: 700,
        marginTop: "0",
        cursor: "pointer",
        boxShadow: "0 2px 5px rgba(220, 38, 38, 0.12)",
        transition: "all 0.2s ease"
    },
    actionWrap: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px"
    },
    dropdownMenu: {
        position: "absolute",
        top: "calc(100% + 10px)",
        right: 0,
        minWidth: "240px",
        backgroundColor: "#f8fbff",
        borderRadius: "0",
        boxShadow: "0 16px 40px rgba(22, 35, 63, 0.2)",
        padding: "8px",
        border: "1px solid rgba(203, 213, 225, 0.9)",
        zIndex: 1000
    },
    dropdownItem: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        width: "100%",
        border: "none",
        background: "transparent",
        color: "#1e293b",
        textAlign: "left",
        padding: "10px 12px",
        borderRadius: "0",
        fontSize: "14px",
        fontWeight: 600
    },
    toggleButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "32px",
        height: "32px",
        borderRadius: "0",
        border: "1px solid rgba(255, 255, 255, 0.25)",
        background: "rgba(255, 255, 255, 0.12)",
        color: "#ffffff",
        fontSize: "13px",
        cursor: "pointer",
        transition: "all 0.2s ease",
    }
};

const TopMenu = () => {
    const [showHide, setShowHide] = useState(false);
    const [helpShowHide, setHelpShowHide] = useState(false);
    const [issueShowHide, setIssueShowHide] = useState(false);
    const [securityShowHide, setSecurityShowHide] = useState(false);
    const [profileShowHide, setProfileShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [profilePicData, setProfilePicData] = useState(null);
    const [firstLogin, setFirstLogin] = useState(false);
    const [welShowHide, setWelShowHide] = useState(false);
    const [helpDocs, setHelpDocs] = useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [logoutProcess, setLogoutProcess] = useState(false);
    const [headerVisible, setHeaderVisible] = useState(true);

    const dropdownRef = useRef(null);
    const welcomeShownRef = useRef(false);
    const securityShownRef = useRef(false);
    const initialMaxTasksRef = useRef(undefined);
    const initialPartnerMaxTasksRef = useRef(undefined);

    const dispatch = useDispatch();
    const currentUser = useMemo(() => getCurrentUser(), []);
    const usrTypeRaw = localStorage.getItem("userType");
    const userDetailsSelector = useSelector(getLoggedUserDetails);

    let usrType = usrTypeRaw ? usrTypeRaw.toLowerCase() : "";
    if (usrType === "pp") {
        const partnerType = userDetailsSelector?.partnerType;
        if (partnerType === "Sub-Contractors") {
            usrType = "subcontractor";
        } else if (partnerType) {
            usrType = partnerType.toLowerCase();
        }
    } else if (usrType === "applicant") {
        usrType = "candidate";
    }

    const userId = currentUser?.id;
    const linkUserId = currentUser?.linkUser;
    const usrIdForLogo = linkUserId || userId;

    // Fetch user details and profile info using RTK Query
    useGetUserDetailsQuery(userId, { skip: !userId || !!linkUserId });
    useGetPartnerUserDetailsQuery(userId, { skip: !userId || !linkUserId });
    useGetUserProfilePicQuery(userId, { skip: !userId });
    useGetUserProfileLogoQuery(usrIdForLogo, { skip: !usrIdForLogo });

    const userProfilePicSelector = useSelector(getUserProfilePic);
    const workbenchHelpDocsSelector = useSelector(getWorkbenchHelpDocs);
    const pageTitleSelector = useSelector(getPageTitle);
    const loginLogoutUserStatusSelector = useSelector(getLoginLogoutUserStatus);
    const partnerUserDetailsSelector = useSelector(getLoggedPartnerUserDetails);

    useEffect(() => {
        if (usrType === "recruiter") {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.RecruiterDoc));
        } else if (usrType === "subcontractor") {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.SubcontractorDoc));
        } else {
            dispatch(loadWorkbenchHelpDocs(config.HelpDocIds.CandidateDoc));
        }
    }, [dispatch, usrType]);

    useEffect(() => {
        if (workbenchHelpDocsSelector) {
            setHelpDocs(workbenchHelpDocsSelector);
        }
    }, [workbenchHelpDocsSelector]);

    useEffect(() => {
        if (userDetailsSelector && currentUser && !currentUser?.linkUser) {
            setUserDetails(userDetailsSelector);

            if (initialMaxTasksRef.current === undefined) {
                initialMaxTasksRef.current = userDetailsSelector.maxtasks;
            }

            if (initialMaxTasksRef.current === null) {
                if (!securityShownRef.current) {
                    securityShownRef.current = true;
                    dispatch(loginStatusUpdate(currentUser.id));
                    setFirstLogin(true);
                    setSecurityShowHide(true);
                }
            } else if (initialMaxTasksRef.current === 1) {
                if (!welcomeShownRef.current) {
                    welcomeShownRef.current = true;
                    dispatch(loginStatusUpdate(currentUser.id));
                    setWelShowHide(true);
                }
            } else {
                setFirstLogin(false);
            }
        }
    }, [userDetailsSelector, currentUser, dispatch]);

    useEffect(() => {
        if (partnerUserDetailsSelector && currentUser) {
            setUserDetails(partnerUserDetailsSelector);

            if (initialPartnerMaxTasksRef.current === undefined) {
                initialPartnerMaxTasksRef.current = partnerUserDetailsSelector.maxtasks;
            }

            if (initialPartnerMaxTasksRef.current === null) {
                if (!securityShownRef.current) {
                    securityShownRef.current = true;
                    dispatch(loginStatusUpdate(currentUser.id));
                    setFirstLogin(true);
                    setSecurityShowHide(true);
                }
            } else if (initialPartnerMaxTasksRef.current === 1) {
                if (!welcomeShownRef.current) {
                    welcomeShownRef.current = true;
                    dispatch(loginStatusUpdate(currentUser.id));
                    setWelShowHide(true);
                }
            } else {
                setFirstLogin(false);
            }
        }
    }, [partnerUserDetailsSelector, currentUser, dispatch]);

    useEffect(() => {
        if (userProfilePicSelector) {
            setProfilePicData(
                process.env.REACT_APP_API_BASEURL + "/ProfilePics/" + userProfilePicSelector
            );
        }
    }, [userProfilePicSelector]);

    useEffect(() => {
        if (loginLogoutUserStatusSelector) {
            setLogoutProcess(false);
            window.location = "/login";
        }
    }, [loginLogoutUserStatusSelector]);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleWelShowHide = () => {
        setWelShowHide((prev) => !prev);
    };

    const handleModalShowHide = () => {
        setShowHide((prev) => !prev);
    };

    const handleHelpShowHide = () => {
        setHelpShowHide((prev) => !prev);
    };

    const handleIssueShowHide = () => {
        setIssueShowHide((prev) => !prev);
    };

    const handleSecurityShowHide = () => {
        setSecurityShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleProfileShowHide = () => {
        setProfileShowHide((prev) => !prev);
        setIsDropdownOpen(false);
    };

    const handleLogout = () => {
        if (currentUser?.id) {
            setLogoutProcess(true);
            dispatch(loginLogoutUpdateStatus(currentUser.id));
        }
    };

    const getPortalLabel = () => {
        if (!usrType) return "Portal";
        return usrType.charAt(0).toUpperCase() + usrType.slice(1) + " Portal";
    };

    const getUserDisplayName = () => {
        const firstName = userDetails?.performername || "";
        const lastName = userDetails?.lastName || "";
        const fullName = `${firstName} ${lastName}`.trim();
        return fullName || "Portal User";
    };

    const getRoleLabel = () => {
        if (usrType !== "candidate") {
            if (currentUser?.linkUser) return currentUser?.role || "Partner User";
            return userDetailsSelector?.title || "User";
        }

        return getFieldData(
            userDetailsSelector?.performerData,
            "projectengagement",
            "PositionTitle"
        ) || "Candidate";
    };

    const getLastLoginLabel = () => {
        return new Date().toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    };

    const handleCurrentTask = async () => { };
    const handleWorkflowTask = () => { };

    const dropdownActionStyle = (isDanger) => ({
        ...HEADER_STYLES.dropdownItem,
        color: isDanger ? "#b91c1c" : "#1e293b"
    });

    const profileImage = profilePicData || "../../assets/img/theme/team-4.png";

    return <>
        <div className="w-100 px-0">
            <div style={HEADER_STYLES.shell} className="col-auto">
                <div className="align-items-center" style={HEADER_STYLES.topRow}>
                    {headerVisible &&
                        <div className="row pt-2 pb-2" style={{ background: "#ffffff", }}>
                            <div className="col-lg-7 col-md-12">
                                <div style={HEADER_STYLES.brandRow}>
                                    <img
                                        src="/assets/Img/logo.png"
                                        alt="Portal logo"
                                        style={HEADER_STYLES.brandLogo}
                                    />

                                </div>

                            </div>

                            <div className="col-lg-5 col-md-12">
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                    <div ref={dropdownRef} style={HEADER_STYLES.profileCard}>
                                        <div style={HEADER_STYLES.profileMain}>
                                            <img
                                                alt="Profile"
                                                src={profileImage}
                                                style={HEADER_STYLES.avatar}
                                            />
                                            <div style={HEADER_STYLES.userContent}>
                                                <div style={HEADER_STYLES.userName}>{getUserDisplayName()}</div>
                                                <div style={HEADER_STYLES.detailRow}>
                                                    <span style={HEADER_STYLES.detailPill}>
                                                        <i className="fa fa-id-badge" aria-hidden="true"></i>
                                                        Reg ID: {currentUser?.id || "-"}
                                                    </span>
                                                    <span style={HEADER_STYLES.detailPill}>
                                                        <i className="fa fa-briefcase" aria-hidden="true"></i>
                                                        Role: {getRoleLabel()}
                                                    </span>
                                                    <span style={HEADER_STYLES.detailPill}>
                                                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                        Last Login: {getLastLoginLabel()}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            aria-label="Open profile actions"
                                            aria-expanded={isDropdownOpen}
                                            onClick={() => setIsDropdownOpen((prev) => !prev)}
                                            style={HEADER_STYLES.dropdownButton}
                                        >
                                            <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                                        </button>

                                        {isDropdownOpen && (
                                            <div style={HEADER_STYLES.dropdownMenu}>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={handleProfileShowHide}
                                                >
                                                    <i className="fa fa-user-circle-o" aria-hidden="true"></i>
                                                    <span>My Profile</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={() => {
                                                        setIsDropdownOpen(false);
                                                        handleModalShowHide();
                                                    }}
                                                >
                                                    <i className="fa fa-lock" aria-hidden="true"></i>
                                                    <span>Change Password</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={handleSecurityShowHide}
                                                >
                                                    <i className="fa fa-shield" />
                                                    <span>Security Questions</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(false)}
                                                    onClick={() => {
                                                        setIsDropdownOpen(false);
                                                        handleHelpShowHide();
                                                    }}
                                                >
                                                    <i className="fa fa-question-circle"></i>
                                                    <span>Help Center</span>
                                                </button>
                                                <button
                                                    type="button"
                                                    style={dropdownActionStyle(true)}
                                                    onClick={handleLogout}
                                                    disabled={logoutProcess}
                                                >
                                                    <i className={logoutProcess ? "fa fa-spinner fa-spin" : "ni ni-user-run"} />
                                                    <span>{logoutProcess ? "Signing out..." : "Logout"}</span>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                    </div>}

                    <div style={HEADER_STYLES.darkBanner}>
                    <div style={HEADER_STYLES.quickRow} className="d-flex justify-content-between align-items-center pt-2 pb-2 flex-wrap">
                        <div style={HEADER_STYLES.quickInfoBlock}>
                            <span style={{ ...HEADER_STYLES.portalBadge, border: '1px solid #000000', background: '#ffffff', color: '#000000', boxShadow: 'none' }}>{getPortalLabel()}</span>
                        </div>
                        <div style={HEADER_STYLES.actionWrap}>
                            <button
                                type="button"
                                onClick={() => setWelShowHide(true)}
                                style={HEADER_STYLES.quickButton}
                            >
                                <i className="fa fa-envelope-open mr-2" aria-hidden="true"></i>
                                Welcome Letter
                            </button>
                            <button
                                type="button"
                                onClick={handleIssueShowHide}
                                title="Any defects/issues found in the portal can be registered in the customer support portal."
                                style={HEADER_STYLES.quickButton}
                            >
                                <i className="fa fa-life-ring mr-2" aria-hidden="true"></i>
                                Customer Support
                            </button>
                            <button
                                type="button"
                                onClick={handleHelpShowHide}
                                style={HEADER_STYLES.quickButton}
                            >
                                <i className="fa fa-question-circle mr-2" aria-hidden="true"></i>
                                Help
                            </button>
                            <button
                                type="button"
                                onClick={handleLogout}
                                disabled={logoutProcess}
                                style={HEADER_STYLES.logoutButton}
                            >
                                <i className={logoutProcess ? "fa fa-spinner fa-spin mr-2" : "ni ni-user-run mr-2"} />
                                {logoutProcess ? "Signing out..." : "Logout"}
                            </button>
                        </div>
                    </div>

                    <div style={HEADER_STYLES.titleSupportWrap}>
                        <div style={HEADER_STYLES.titleSupport}>
                            <span>
                                Human Resources Information Management System (HRIMS)
                            </span>
                        </div>
                        <button
                            type="button"
                            onClick={() => setHeaderVisible(!headerVisible)}
                            title={headerVisible ? "Hide Header" : "Show Header"}
                            style={HEADER_STYLES.toggleButton}
                        >
                            <i className={`fa fa-chevron-${headerVisible ? "up" : "down"}`} aria-hidden="true"></i>
                        </button>
                    </div>
                    </div>
                </div>
            </div>

            {showHide &&
                <ChangePassword
                    handleModalShowHide={handleModalShowHide}
                    showHide={showHide}
                ></ChangePassword>}
            {profileShowHide &&
                <Profile
                    handleProfileShowHide={handleProfileShowHide}
                    profileShowHide={profileShowHide}
                    usrType={usrType}
                ></Profile>}
            {helpShowHide &&
                <Help
                    helpShowHide={helpShowHide}
                    handleHelpShowHide={handleHelpShowHide}
                    module={pageTitleSelector}
                    helpDocs={helpDocs}
                ></Help>}
            {issueShowHide &&
                <SupportPupup
                    handleIssueShowHide={handleIssueShowHide}
                    issueShowHide={issueShowHide}
                    handleCurrentTask={handleCurrentTask}
                    handleWorkflowTask={handleWorkflowTask}
                ></SupportPupup>}

            {securityShowHide && <AddSecurityQuestion
                firstLogin={firstLogin}
                securityShowHide={securityShowHide}
                handleSecurityShowHide={handleSecurityShowHide}
                userDetails={userDetails}
            ></AddSecurityQuestion>}
            {welShowHide && <WelcomePage
                userDetails={userDetails}
                welShowHide={welShowHide}
                handleWelShowHide={handleWelShowHide}
            ></WelcomePage>}
        </div>
    </>
}

export default TopMenu;
